import { Observable } from 'rxjs';
import { CatalogRepository, ApiResponse } from '../domain/catalog/repository';
import { CatalogSearchResponse } from '../domain/catalog/model';
import HttpClient from '../utils/http-client';

export class CatalogRepositoryImplementation extends CatalogRepository {
    searchCatalog(
        uid: string,
        cid: string | null,
        query = "",
        page = 1,
        limit = 20,
        type = "all",
        onlyEnabled = true
    ): Observable<ApiResponse<CatalogSearchResponse>> {
        const httpClient = new HttpClient(uid, cid);
        const params: Record<string, unknown> = {
            page,
            limit,
            type,
            only_enabled: onlyEnabled
        };
        if (query && query.trim() !== '') {
            params.query = query.trim();
        }

        return httpClient.get('/catalog/search', params);
    }
}
